import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import HighlightedMerchCard from './HighlightedMerchCard';
import { ShadowCardGrid, ShadowColumn, StyledCardGrid, StyledCardGridWrapper } from './MerchCardSharedComponents';
import { getMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import { FREE, STARTER } from 'self-service-api/constants/ProductLevels';
import HighlightedFreeCard from './HighlightedFreeCard';
import { useSelector } from 'react-redux';
import { ENTERPRISE } from '../../constants/routing/Tabs';
import Screens from '../../constants/routing/Screens';
import { isAnyStarterGWP2023EligibleSelector } from '../../selectors/PromotionSelectors';
import { CMS } from 'self-service-api/constants/ProductLines';
import StarterCrmSuiteCtaCardGWP from '../product-pages/StarterCrmSuiteCtaCardGWP';
import { Section } from '../common/SharedComponents';

const HubTierInfo = ({
  productLine,
  selectedTab
}) => {
  const isStarterGWP = useSelector(isAnyStarterGWP2023EligibleSelector);
  const productLevels = getMerchCardsToShow({
    tab: selectedTab
  });
  const shouldDisplaySuiteCard = isStarterGWP && selectedTab !== ENTERPRISE;
  const merchCardComponents = productLevels.map((productLevel, index) => {
    const commonStyles = {
      msGridColumn: index + 1,
      // IE
      gridColumnStart: index + 1,
      paddingLeft: 28,
      paddingRight: 28
    };

    if (FREE === productLevel) {
      return /*#__PURE__*/_jsx(HighlightedFreeCard, {
        productLine: productLine,
        commonStyles: commonStyles,
        perMonth: false
      }, `${productLine}-${productLevel}`);
    }

    const disclaimer = productLevel === STARTER && isStarterGWP && productLine !== CMS ? 'pricingPage.promotions.starterGWPDisclaimer' : undefined;
    return /*#__PURE__*/_jsx(HighlightedMerchCard, {
      productLevel: productLevel,
      productLine: productLine,
      commonStyles: commonStyles,
      selectedTab: selectedTab,
      disclaimer: disclaimer
    }, `${productLine}-${productLevel}`);
  });
  const shadowColumns = productLevels.map(productLevel => /*#__PURE__*/_jsx(ShadowColumn, {}, `${productLine}-${productLevel}-shadow`));
  return /*#__PURE__*/_jsx(Section, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex-column align-center justify-center",
      children: [shouldDisplaySuiteCard && /*#__PURE__*/_jsx(StarterCrmSuiteCtaCardGWP, {
        screen: Screens[productLine]
      }), /*#__PURE__*/_jsxs(StyledCardGridWrapper, {
        columns: productLevels.length,
        children: [/*#__PURE__*/_jsx(StyledCardGrid, {
          columns: productLevels.length,
          children: merchCardComponents
        }), /*#__PURE__*/_jsx(ShadowCardGrid, {
          columns: productLevels.length,
          "aria-hidden": "true",
          children: shadowColumns
        })]
      })]
    })
  });
};

export default HubTierInfo;